import { createContext } from 'react';

const Context = createContext<any>(null);

export default Context;
